<template>
  <div
    class="owal-bar__container light top"
  >
    <span
      class="owal-bar-buttons__container"
    >
      <span
        v-for="item in leftItems"
        :key="item"
        class="clickable"
        @click="$emit('click', item)"
      >
        {{ item }}
      </span>
    </span>
    <span
      class="owal-bar-title__container"
    >
      {{ title }}
    </span>
    <span
      class="owal-bar-buttons__container"
    >
      <span
        v-for="item in rightItems"
        :key="item"
        class="clickable"
        @click="$emit('click', item)"
      >
        {{ item }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'OwalTitleBar',
  props: {
    /** The items to show in the left of the bar. */
    left: {
      type: [Array, String],
      default: () => [],
    },
    /** The items to show in the right of the bar. */
    right: {
      type: [Array, String],
      default: () => [],
    },
    /** The title to show in the bar. */
    title: {
      type: String,
      default: 'Title',
    },
  },
  computed: {
    leftItems () {
      if (Array.isArray(this.left)) {
        return this.left
      } else {
        return [this.left]
      }
    },
    rightItems () {
      if (Array.isArray(this.right)) {
        return this.right
      } else {
        return [this.right]
      }
    },
  },
}
</script>

<style scoped>
/** The bar above the report. */
.owal-bar__container {
  min-height: 3.1875rem;
  max-height: 9.4377rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: 0.5rem;
  overflow: hidden;
  align-items: center;
  align-content: center;
  width: 100%;
  height: 3.1875rem;
  flex-shrink: 0;
  margin: 0;
  padding: 0 0.5rem;
}

/** A dark background for the search bar. */
.dark {
  color: #eff2f7;
  background: #324057;
}

/** A light background for the search bar. */
.light {
  color: #324057;
  background: #eff2f7;
}

/** When the bar is at the top of content, round the top corners */
.top {
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}

/** The title. */
.owal-bar-title__container {
  font-weight: bold;
  color: #324057;
}

.clickable {
  cursor: pointer;
  color: #007aff;
}

.clickable:hover {
  opacity: 0.75;
}
</style>
